import { Component, OnInit, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalRepositoryComponent } from '@component/modal-repository/modal-repository.component';
import { ModalDeleteRepositoryComponent } from '@component/modal-delete-repository/modal-delete-repository.component';

import { Repository } from '@model/Repository';

@Component({
  selector: 'app-card-repository',
  templateUrl: './card-repository.component.html',
  styleUrls: ['./card-repository.component.scss']
})
export class CardRepositoryComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() repository: Repository;
  @Input() isAuthor: boolean = true;

  public modalOptions: NgbModalOptions;
  public colors: any[] = ['card-default', 'card-primary', 'card-success', 'card-danger', 'card-warning', 'card-info', 'card-bdc'];

  constructor(
    private modalService: NgbModal,
  ) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    };
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.borderLeftColorCard();
  }

  ngOnDestroy() {}

  editRepository(repository: Repository) {
    const modal = this.modalService.open(ModalRepositoryComponent, this.modalOptions);
    modal.componentInstance.repository = {...repository};
    modal.componentInstance.isAuthor = this.isAuthor;
  }

  openDelete(repository: Repository) {
    let modal = this.modalService.open(ModalDeleteRepositoryComponent);

    // modal.componentInstance.repository = {
    //   id: repository.id,
    //   uri: 'repositories',
    //   name: `${repository.name}`
    // };
    modal.componentInstance.repository = repository;
  }

  openRepo() {
    localStorage.setItem('showMenuCardProject', String(this.isAuthor));
  }

  borderLeftColorCard(){
    let obj = document.querySelectorAll('.card');
    let i=0;
    obj.forEach(el=>{
      if(i > 7){i=0}
      $(el).addClass(this.colors[i++]);
    });
  }
}
